export default __webpack_public_path__ + "static/media/3.3539c043.jpg";